import { render, staticRenderFns } from "./KMIPersonalDetailsComponent.vue?vue&type=template&id=01591356"
import script from "./KMIPersonalDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./KMIPersonalDetailsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports